import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Preloader } from '@/components/Preloader';
import { MiniFaqs, MINIFAQ_SOURCES } from '@/containers/MiniFaqs';
import { SuspendResidenceWarning } from '@/components/Warnings/SuspendResidenceWarning';
import Analytics from '@/analyticsGA';
import { useGetMe } from '@/hooks/useGetMe';
import { MessageHandler } from './components/MessageHandler';
import { TopUpForm } from './components/TopUpForm';
import { TopUpResultModal } from '@/modals/TopUpResultModal';
import { MODAL_IDS } from '@/kit/Modal/keys';
import { useModal } from '@/providers/modal';
import s from './index.module.scss';

const FundsAddPage = () => {
  const { isVerified, veriffStatus, isSuspended, user } = useGetMe();
  const [searchParams] = useSearchParams();
  const paymentToken = searchParams.get('payment_reference');
  const { openSingleModal } = useModal();

  useEffect(() => {
    Analytics.pageNavigation('Cash');
    Analytics.addCashPage();
  }, []);

  useEffect(() => {
    if (paymentToken) {
      openSingleModal(MODAL_IDS.top_up_result_modal);
    }
  }, [paymentToken, openSingleModal]);

  if (!user) {
    return (
      <div className={s.page}>
        <Preloader className={s.preloader} />
      </div>
    );
  }

  if (isSuspended) {
    return (
      <div className={s.page} style={{ minHeight: 0 }}>
        <SuspendResidenceWarning />
      </div>
    );
  }

  return (
    <div className={s.page}>
      {veriffStatus && (isVerified ? <TopUpForm /> : <MessageHandler />)}
      <MiniFaqs source={MINIFAQ_SOURCES.addCash} />
      <TopUpResultModal />
    </div>
  );
};

export default FundsAddPage;
